import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Хелпер для shadcn-стиля компонентов: объединяет classNames + резолвит конфликты Tailwind.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
